export default "__VITE_ASSET__fdj5RvH5__"